import { RootState } from '../../app/store'

export const selectUser = (state: RootState) => state.users.user
export const selectUsersLoading = (state: RootState) => state.users.isLoading
export const selectUsersError = (state: RootState) => state.users.error
